const paths = [
  'products/papersign',
  'pdf-templates',
  'tools/free-signature-generator-online',
];

const useIsPapersign = (location = null) => {
  if (!location) return false;
  return !!paths.find((path) => location.pathname?.includes(path));
};

export default useIsPapersign;
